
.answer-form-wrap {
  min-height: 70vh;
  overflow-y: auto;
}
